var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _line, _rect7, _path, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCpCatalogGlueIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.e,.f{fill:none;}.b{fill:#3c3c46;opacity:0.2;}.c{fill:#fff;}.c,.e,.f,.g{stroke:#3c3c46;stroke-linejoin:round;stroke-width:2px;}.c,.f,.g{stroke-linecap:round;}.d{fill:#89d9fb;}.e{stroke-dasharray:4 2;}.g{fill:#3ca4ef;fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-catalog-glue-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 30,
    y: 23,
    width: 86,
    height: 100
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 102,
    y: 17.1,
    width: 4,
    height: 99.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 98,
    y: 17.1,
    width: 4,
    height: 99.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 94,
    y: 17.1,
    width: 4,
    height: 99.8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 24,
    y: 17,
    width: 70,
    height: 100
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 31,
    y1: 17,
    x2: 31,
    y2: 117
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 24,
    y: 17,
    width: 70,
    height: 100
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M72.65,47.72l-2.7,2.7a7.5,7.5,0,1,0,0,10.6l8.45,8.45A19.45,19.45,0,1,1,78.4,42Z"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 50.06,
    y1: 86.69,
    x2: 75.06,
    y2: 86.69
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 50.06,
    y1: 91.69,
    x2: 75.06,
    y2: 91.69
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpCatalogGlueIcon);
export default __webpack_public_path__ + "static/media/CP-catalog-glue-icon.0e3ff666e77d75c69eca52bebeec5363.svg";
export { ForwardRef as ReactComponent };